import { Component, Input } from '@angular/core';
import { MENU_DROPDOWN, SHORTCUT_BUTTONS, TCV_ROUTE } from '@common/constants/header.constants';
import { IDropdownButton } from '@common/interfaces/header-menu.interface';
import { IButton } from '@common/interfaces/button.interface';
import { NavigationService } from '@services/navigation/navigation.service';
import { Subscription } from 'rxjs';
import { HOME_ROUTE } from '@common/constants/routes.constants';

@Component({
  selector: 'app-header-desktop',
  templateUrl: './header-desktop.component.html',
  styleUrls: ['./header-desktop.component.scss'],
})
export class HeaderDesktopComponent {

  @Input() currentRoute: string;

  public menuDropdown: IDropdownButton[];
  public shortcutButtons: IButton[];
  public subscription: Subscription;
  public homeRoute: string;
  public tcvRoute: string;

  constructor(
    private navService: NavigationService,
  ) {
    this.menuDropdown = MENU_DROPDOWN;
    this.shortcutButtons = SHORTCUT_BUTTONS;
    this.homeRoute = HOME_ROUTE;
    this.tcvRoute = TCV_ROUTE;
  }

  public clickEvent(url: string) {
    this.navService.goTo(url);
  }

  public newWindowClickEvent(url: string) {
    this.navService.windowOpen(url);
  }

}
